// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__j3pjV","author":"Table_author__28PN4","authorImage":"Table_authorImage__2PK6A","unreadRow":"Table_unreadRow__K4sJV"};